import _ from "lodash";
import axios from "axios";

class Config {
    public TMS_API_URL = "";
    public LOGIN_LOGO_URL = require("@/assets/logo.png");
    public INTERNAL_LOGIN_ENABLED = true;
    public IDENTITY_LOGIN_ENABLED = false;
    public INTERNAL_IDENTITY_URL = "http://identity-qa.roomis.com.cn/auth/realms/tms/protocol/cas";
    public CERTIFICATE_FILE_KEY = "certificates/default-certificate-background.jpg";
    public HOME_BANNER = [require("@/assets/home_banner_1.png"), require("@/assets/home_banner_2.png")];
    public SCHOOL_QR_CODE = "";
    public IM_URL = "";
    public EXIST_SINGLE_ORG = true;
    public COPY_PLAN_ENABLED = false;
    public LINK_TO_TC = "app"; // 链接到TC的方式：app or h5
    public LINK_TO_TC_URL = "";
}

const config = new Config();

if (!_.isEmpty(window["TMS_API_URL"])) {
    config.TMS_API_URL = window["TMS_API_URL"];
}
if (!_.isEmpty(window["LOGIN_LOGO_URL"])) {
    config.LOGIN_LOGO_URL = window["LOGIN_LOGO_URL"];
}
if (window["INTERNAL_LOGIN_ENABLED"] === true || window["INTERNAL_LOGIN_ENABLED"] === false) {
    config.INTERNAL_LOGIN_ENABLED = window["INTERNAL_LOGIN_ENABLED"];
}
if (!_.isEmpty(window["INTERNAL_IDENTITY_URL"])) {
    config.INTERNAL_IDENTITY_URL = window["INTERNAL_IDENTITY_URL"];
}
if (!_.isEmpty(window["CERTIFICATE_FILE_KEY"])) {
    config.CERTIFICATE_FILE_KEY = window["CERTIFICATE_FILE_KEY"];
}
if (!_.isEmpty(window["HOME_BANNER"])) {
    config.HOME_BANNER = window["HOME_BANNER"];
}
if (!_.isEmpty(window["SCHOOL_QR_CODE"])) {
    config.SCHOOL_QR_CODE = window["SCHOOL_QR_CODE"];
}
if (!_.isEmpty(window["IM_URL"])) {
    config.IM_URL = window["IM_URL"];
}
if (_.isBoolean(window["COPY_PLAN_ENABLED"])) {
    config.COPY_PLAN_ENABLED = window["COPY_PLAN_ENABLED"];
}
if (!_.isEmpty(window["LINK_TO_TC"])) {
    config.LINK_TO_TC = window["LINK_TO_TC"];
}
if (!_.isEmpty(window["LINK_TO_TC_URL"])) {
    config.LINK_TO_TC_URL = window["LINK_TO_TC_URL"];
}
if (_.isBoolean(window["IDENTITY_LOGIN_ENABLED"])) {
    config.IDENTITY_LOGIN_ENABLED = window["IDENTITY_LOGIN_ENABLED"];
}
//TODO to be better
axios.get(`${config.TMS_API_URL}/api/portal/orgs`).then(resp => {
    if (resp.data.data && resp.data.data.length > 1) {
        config.EXIST_SINGLE_ORG = false;
    }
});

export default config;
